import { Fragment } from "react";

import type { Action } from "../../action/Action";
import IconButton from "../Button/IconButton";
import Centered from "../Centered";
import Divider from "../Divider";
import Spacer from "../space/Spacer";
import ListFrame from "./ListFrame";

type ListProps<Item> = {
    items: Item[];
    keyExtractor: (item: Item) => string;
    children: (item: Item) => React.ReactNode;
    empty?: React.ReactNode;
    onCreate?: Action;
};

export default function List<Item>(props: ListProps<Item>) {
    const { items, keyExtractor, children, empty = null, onCreate } = props;
    return (
        <ListFrame>
            {items.length === 0
                ? empty
                : items.map((item, i) => (
                      <Fragment key={keyExtractor(item)}>
                          {i > 0 && <Divider />}
                          {children(item)}
                      </Fragment>
                  ))}
            {onCreate && items.length ? (
                <Fragment>
                    <Divider />
                    <Spacer scale={2} />
                    <Centered>
                        <IconButton icon="plus" action={onCreate} feeling="minor" role="minor" />
                    </Centered>
                </Fragment>
            ) : null}
        </ListFrame>
    );
}
